import React from 'react';
export const Adoptable24 = ({ className })=>/*#__PURE__*/ React.createElement("svg", {
        width: "12",
        height: "12",
        viewBox: "0 0 12 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.8 6.79988V5.99988H2L2 6.79988H2.8Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.6 7.59988V6.79988L2.8 6.79988L2.8 7.59988H3.6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.6 6.79988V5.99988H2.8V6.79988L3.6 6.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M3.6 5.99988V5.19988H2.8L2.8 5.99988H3.6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.4 8.39988V7.59988L3.6 7.59988L3.6 8.39988H4.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.4 7.59988V6.79988H3.6V7.59988L4.4 7.59988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.4 6.79988V5.99988H3.6V6.79988H4.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.4 5.99988V5.19988H3.6V5.99988H4.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M4.4 5.19988L4.4 4.39988H3.6L3.6 5.19988H4.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 9.19988V8.39988L4.4 8.39988L4.4 9.19988H5.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 8.39988V7.59988H4.4V8.39988L5.2 8.39988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 7.59988V6.79988H4.4V7.59988H5.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 6.79988V5.99988H4.4V6.79988H5.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 5.99988L5.2 5.19988H4.4V5.99988H5.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 5.19988V4.39988H4.4L4.4 5.19988H5.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.2 4.39988V3.59988H4.4L4.4 4.39988H5.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 9.99988V9.19988L5.2 9.19988L5.2 9.99988H6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 9.19988V8.39988H5.2V9.19988L6 9.19988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 8.39988V7.59988H5.2V8.39988H6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 7.59988V6.79988L5.2 6.79988V7.59988H6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 6.79988V5.99988L5.2 5.99988V6.79988L6 6.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 5.99988L6 5.19988L5.2 5.19988L5.2 5.99988L6 5.99988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 5.19988V4.39988H5.2V5.19988L6 5.19988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 4.39988V3.59988H5.2V4.39988H6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6 3.59988L6 2.79988H5.2L5.2 3.59988H6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 9.19988V8.39988H6V9.19988L6.8 9.19988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 8.39988V7.59988H6V8.39988H6.8Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 7.59988V6.79988L6 6.79988V7.59988H6.8Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 6.79988V5.99988L6 5.99988V6.79988L6.8 6.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 5.99988L6.8 5.19988L6 5.19988L6 5.99988L6.8 5.99988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 5.19988V4.39988H6V5.19988L6.8 5.19988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.8 4.39988L6.79995 3.59988H6V4.39988H6.8Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 4.39988V3.59988L6.79995 3.59988L6.8 4.39988L7.6 4.39988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.79995 3.59988L6.79995 2.79988L6 2.79988L6 3.59988H6.79995Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 3.59988V2.79988L6.79995 2.79988L6.79995 3.59988L7.6 3.59988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M6.79995 2.79988L6.8 1.99988L6 1.99988L6 2.79988L6.79995 2.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 8.39988V7.59988H6.8V8.39988L7.6 8.39988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 7.59988V6.79988H6.8V7.59988H7.6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 6.79988V5.99988H6.8V6.79988H7.6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 5.99988V5.19988H6.8L6.8 5.99988H7.6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 5.19988V4.39988L6.8 4.39988V5.19988H7.6Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M7.6 2.79988V1.99988L6.8 1.99988L6.79995 2.79988L7.6 2.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.4 7.59988V6.79988H7.6V7.59988L8.4 7.59988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.4 6.79988V5.99988H7.6V6.79988H8.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.4 5.99988V5.19988H7.6V5.99988H8.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.4 5.19988V4.39988L7.6 4.39988V5.19988H8.4Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.4 2.79988V1.99988L7.6 1.99988V2.79988L8.4 2.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M8.4 3.19988V2.39988L7.6 2.39988V3.19988L8.4 3.19988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.2 6.79988V5.99988H8.4V6.79988L9.2 6.79988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.2 5.99988V5.19988H8.4V5.99988H9.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.2 5.19988V4.39988H8.4V5.19988H9.2Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M9.2 3.19988V1.99988L8.4 1.99988V3.19988L9.2 3.19988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 5.99988V5.19988H9.2V5.99988L10 5.99988Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 5.19988V4.39988H8.8V5.19988H10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 4.39988V3.59988H8.8V4.39988H10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 3.59988V2.79988H8.8V3.59988H10Z",
        fill: "currentColor"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M10 2.79988V1.99989L9.2 1.99988L9.2 2.79989L10 2.79988Z",
        fill: "currentColor"
    }));
Adoptable24.displayName = 'Adoptable24';
export default Adoptable24;

//# sourceMappingURL=24x24.js.map